<template>
    <div class="component">
        <p class="label">
            {{ question.name }}
            <span v-if="question.mustAnswer" class="required">*</span>
        </p>
        <van-field
            style="background:#ffffff"
            left-icon="calendar-o"
            right-icon="arrow"
            placeholder="请选择时间"
            :disabled="disabled"
            @click="onClick"
            :value="getValue"
            :rules="rule"
            readonly
        ></van-field>
        <van-popup v-model="show" position="bottom">
            <van-datetime-picker
                ref="date"
                v-model="currentDate"
                :title="question.name"
                :type="date[question.showDateFormat]"
                :value="value"
                @change="handleChange"
                @confirm="handleConfirm"
                @cancel="show = false"
            />
        </van-popup>
        <g-question-description v-model="showDes" :list="list"/>
    </div>
</template>

<script>
    import moment from 'moment'
    import GQuestionDescription from "./GQuestionDescription.vue";
    export default {
        name: 'GDate',
        components: {GQuestionDescription},
        props: ['question', 'value', 'rule','disabled'],
        model: {
            prop: 'value',
            event: 'customChange'
        },
        computed: {
            list() {
                return this.question.remark.split('\n')
            },
            getValue() {
                let date;
                if (!this.value) {
                    return ''
                }
                const m = moment(this.value);
                switch (this.question.showDateFormat) {
                    case 'yyyy-MM-dd HH:mm':
                        date = m.format('YYYY-MM-DD HH:mm')
                        break;
                    case 'yyyy-MM-dd':
                        date = m.format('YYYY-MM-DD')
                        break;
                    case 'yyyy-MM':
                        date = m.format('YYYY-MM')
                        break;
                    case 'HH:mm':
                        date = date = this.value ? this.value.slice(11, 16) : '00:00';
                        break;
                    default:
                        break;
                }
                return date
            }
        },
        data() {
            return {
                show: false,
                showDes: false,
                currentDate: new Date(),
                date: {
                    'yyyy-MM-dd HH:mm': 'datetime',
                    'yyyy-MM-dd': 'date',
                    'yyyy-MM': 'year-month',
                    'HH:mm': 'time',
                }
            }
        },
        methods: {
            onClick(){
                console.log(this.disabled)
                if(!this.disabled){
                    this.show = true
                }
            },
            handleConfirm() {
                this.handleChange();
                this.show = false;
            },

            handleChange() {
                const getPicker = this.$refs.date.getPicker();
                const dateArr = getPicker.getValues();
                let date;
                switch (this.question.showDateFormat) {
                    case 'yyyy-MM-dd HH:mm':
                        date = `${dateArr[0]}-${dateArr[1]}-${dateArr[2]} ${dateArr[3]}:${dateArr[4]}:00`
                        break;
                    case 'yyyy-MM-dd':
                        date = `${dateArr[0]}-${dateArr[1]}-${dateArr[2]} 00:00:00`
                        break;
                    case 'yyyy-MM':
                        date = `${dateArr[0]}-${dateArr[1]}-00 00:00:00`
                        break;
                    case 'HH:mm':
                        date = `0000-00-00 ${dateArr[0]}:${dateArr[1]}:00`
                        break;
                    default:
                        break;
                }
                this.$emit('customChange', date)
                this.$emit('change')
            },

            formatter(type, val) {
                console.log(type, val)
                if (type === 'year') {
                    return `${val}年`
                } else if (type === 'month') {
                    return `${val}月`
                } else if (type === 'day') {
                    return `${val}日`
                } else if (type === 'hour') {
                    return `${val}时`
                } else if (type === 'minute') {
                    return `${val}分`
                } else {
                    return val
                }
            }
        }
    }
</script>

<style lang="less" scoped>
    @import './base.less';
    .component {
        .van-cell {
            padding: 32px ;
            border-radius: 16px;
            overflow: hidden;
            font-size:30px;
        }
    }
</style>
